import CONFIG from '../config';

export const poll = (fn: () => boolean, timeout: number, interval: number) => {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  var checkCondition = function(resolve: any, reject: any) {
    // If the condition is met, we're done!
    var result = fn();
    if (result) {
      resolve(result);
    }
    // If the condition isn't met but the timeout hasn't elapsed, go again
    else if (Number(new Date()) < endTime) {
      setTimeout(checkCondition, interval, resolve, reject);
    }
    // Didn't match and too much time, reject!
    else {
      reject(new Error('timed out for ' + fn + ': ' + arguments));
    }
  };

  return new Promise<boolean>(checkCondition);
};

export const pollWindowVariable = async (
  property: string,
  timeout: number = 2000
) => {
  try {
    const w = window as any;
    await poll(
      () => {
        return w[property];
      },
      timeout,
      150
    );

    return w[property];
  } catch (error) {
    return null;
  }
};

export const pollWindowVariables = (properties: string[]) => {
  const promises = properties.map(property => {
    return new Promise(resolve => resolve(pollWindowVariable(property)));
  });

  return promises;
};

//Tracking utils
export const sendWaData = async ({
  siteSection,
  pageName
}: {
  siteSection: string;
  pageName: string;
}) => {
  try {
    const wa_data = await pollWindowVariable('wa_data');
    if (wa_data) {
      setTimeout(() => {
        wa_data.siteSection = siteSection;
        wa_data.pageName = pageName;
      }, 0);
    }
  } catch (error) {
    console.error(error);
  }
};

//tracking function
export const adobeTrack = (event: string, action : string = 'clickEvent') => {
  try{
    (window as any).tc_events_100(null, event, { ACTION: action });
  }catch (e){
    console.log(e)
  }
};

